import { NavigateBeforeSharp, NavigateNextSharp } from '@mui/icons-material/'

import { Button, Box, Stack, Paper } from '@mui/material'
// import Grid2 from '@mui/material/Unstable_Grid2/Grid2'
import React from 'react'
// import { Item } from './Item.js'
import PostButtons from './PostButtons.js'
import appUtilities from '../utilities/appUtilities.js'
import useMediaQuery from '@mui/material/useMediaQuery'

import { useTheme } from '@mui/material/styles'
export default function NavButtonRow({
    handlePgNav,
    clearAll = null,
    deleteLast = null,
    validFence,
    postOnMap = false,
}) {
    const theme = useTheme()

    const isButtonRoom = !useMediaQuery(theme.breakpoints.down('sm'))
    const buttonText1 = isButtonRoom ? 'Previous' : 'Prev'
    return (
        <Stack
            direction={'row'}
            justifyContent={'space-between'}
            // container
            // xs={12}
            // sx={{
            //     '& .MuiButtonBase-root': {
            //         xs: { paddingLeft: '8px', paddingRight: '8px' },
            //         md: { paddingLeft: '16px', paddingRight: '16px' },
            //     },
            //     '& .MuiPaper-root': {
            //         xs: { paddingLeft: '16px', paddingRight: '16px' },
            //         md: { paddingLeft: '16px', paddingRight: '16px' },
            //     },
            // }}
        >
            <Box
            // xs={3}
            // sx={{
            //     display: 'flex',
            //     justifyContent: 'flex-start',
            // }}
            >
                <Paper
                    elevation={0}
                    sx={{ p: 2, px: { xs: 1, sm: 2 }, mr: '0px', pr: '0px' }}
                >
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() =>
                            handlePgNav(appUtilities.navDirections.previous)
                        }
                        startIcon={<NavigateBeforeSharp />}
                    >
                        {buttonText1}
                    </Button>
                </Paper>
            </Box>

            {clearAll && (
                <PostButtons
                    clearAll={clearAll}
                    deleteLast={deleteLast}
                    postOnMap={postOnMap}
                />
            )}

            <Box
            // xs={3}
            // sx={{
            //     display: 'flex',
            //     justifyContent: 'flex-end',
            // }}
            >
                <Paper
                    elevation={0}
                    sx={{ p: 2, px: { xs: 1, sm: 2 }, ml: '0px', pl: '0px' }}
                >
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() =>
                            handlePgNav(appUtilities.navDirections.next)
                        }
                        endIcon={<NavigateNextSharp />}
                        disabled={!validFence}
                    >
                        Next
                    </Button>
                </Paper>
            </Box>
        </Stack>
    )
}
